import { CodeBase } from "./_codeBase";

/** 進捗区分*/
export class ProgressDiv extends CodeBase<ProgressDiv>
{

    /** 進捗区分:"a", "　", "　"*/
    public static readonly A: ProgressDiv = new ProgressDiv("a", "　", "　");

    /** 進捗区分:"b", "新規", "○"*/
    public static readonly B: ProgressDiv = new ProgressDiv("b", "新規", "○");

    /** 進捗区分:"d", "完了", "●"*/
    public static readonly D: ProgressDiv = new ProgressDiv("d", "完了", "●");

    /** 進捗区分:"f", "中断", "△"*/
    public static readonly F: ProgressDiv = new ProgressDiv("f", "中断", "△");

    /** 進捗区分:"g", "該当無", "×"*/
    public static readonly G: ProgressDiv = new ProgressDiv("g", "該当無", "×");

    /** 進捗区分:"e", "完了見込", "▲"*/
    public static readonly E: ProgressDiv = new ProgressDiv("e", "完了見込", "▲");

    /** 進捗区分:"i", "キャンセル", "■"*/
    public static readonly I: ProgressDiv = new ProgressDiv("i", "キャンセル", "■");

    /** 進捗区分:"j", "進捗率(10%)", "10%"*/
    public static readonly J: ProgressDiv = new ProgressDiv("j", "進捗率(10%)", "10%");

    /** 進捗区分:"k", "進捗率(20%)", "20%"*/
    public static readonly K: ProgressDiv = new ProgressDiv("k", "進捗率(20%)", "20%");

    /** 進捗区分:"l", "進捗率(30%)", "30%"*/
    public static readonly L: ProgressDiv = new ProgressDiv("l", "進捗率(30%)", "30%");

    /** 進捗区分:"m", "進捗率(40%)", "40%"*/
    public static readonly M: ProgressDiv = new ProgressDiv("m", "進捗率(40%)", "40%");

    /** 進捗区分:"n", "進捗率(50%)", "50%"*/
    public static readonly N: ProgressDiv = new ProgressDiv("n", "進捗率(50%)", "50%");

    /** 進捗区分:"o", "進捗率(60%)", "60%"*/
    public static readonly O: ProgressDiv = new ProgressDiv("o", "進捗率(60%)", "60%");

    /** 進捗区分:"p", "進捗率(70%)", "70%"*/
    public static readonly P: ProgressDiv = new ProgressDiv("p", "進捗率(70%)", "70%");

    /** 進捗区分:"q", "進捗率(80%)", "80%"*/
    public static readonly Q: ProgressDiv = new ProgressDiv("q", "進捗率(80%)", "80%");

    /** 進捗区分:"r", "進捗率(90%)", "90%"*/
    public static readonly R: ProgressDiv = new ProgressDiv("r", "進捗率(90%)", "90%");

    /** 進捗区分:"s", "進捗率(100%)", "100%"*/
    public static readonly S: ProgressDiv = new ProgressDiv("s", "進捗率(100%)", "100%");

    /** 進捗区分:"c", "継続", "◎"*/
    public static readonly C: ProgressDiv = new ProgressDiv("c", "継続", "◎");

    /** 進捗区分:"h", "予定提出後に変更", "◇"*/
    public static readonly H: ProgressDiv = new ProgressDiv("h", "予定提出後に変更", "◇");


    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ProgressDiv[] {
        return [
            // 並び順を変更（#6213 V2.4）
            //ProgressDiv.A,
            //ProgressDiv.B,
            //ProgressDiv.C,
            //ProgressDiv.D,
            //ProgressDiv.E,
            //ProgressDiv.F,
            //ProgressDiv.G,
            //ProgressDiv.H,
            //ProgressDiv.I,
            //ProgressDiv.J,
            //ProgressDiv.K,
            //ProgressDiv.L,
            //ProgressDiv.M,
            //ProgressDiv.N,
            //ProgressDiv.O,
            //ProgressDiv.P,
            //ProgressDiv.Q,
            //ProgressDiv.R,
            //ProgressDiv.S,
            ProgressDiv.A,
            ProgressDiv.B,
            ProgressDiv.D,
            ProgressDiv.F,
            ProgressDiv.G,
            ProgressDiv.E,
            ProgressDiv.I,
            ProgressDiv.J,
            ProgressDiv.K,
            ProgressDiv.L,
            ProgressDiv.M,
            ProgressDiv.N,
            ProgressDiv.O,
            ProgressDiv.P,
            ProgressDiv.Q,
            ProgressDiv.R,
            ProgressDiv.S,
            ProgressDiv.C,
            ProgressDiv.H,
        ];
    }
}
